export enum EaStatus {
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success'
}
